<template>
  <svg
    width="64"
    height="65"
    viewBox="0 0 64 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_17471_95706)">
      <path
        d="M32.0003 0.5H31.9997C14.3267 0.5 0 14.8267 0 32.4997V32.5003C0 50.1733 14.3267 64.5 31.9997 64.5H32.0003C49.6733 64.5 64 50.1733 64 32.5003V32.4997C64 14.8267 49.6733 0.5 32.0003 0.5Z"
        fill="#066E60"
      />

      <path
        d="M25.4986 32.4997C25.4986 28.9011 22.5814 25.9839 18.9828 25.9839C15.3843 25.9839 12.4671 28.9011 12.4671 32.4997C12.4671 36.0982 15.3843 39.0154 18.9828 39.0154C22.5814 39.0154 25.4986 36.0982 25.4986 32.4997Z"
        fill="white"
      />

      <path
        d="M51.5323 32.4997C51.5323 28.9011 48.6151 25.9839 45.0165 25.9839C41.418 25.9839 38.5008 28.9011 38.5008 32.4997C38.5008 36.0982 41.418 39.0154 45.0165 39.0154C48.6151 39.0154 51.5323 36.0982 51.5323 32.4997Z"
        fill="white"
      />
    </g>

    <defs>
      <clipPath id="clip0_17471_95706">
        <rect
          width="64"
          height="64"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
  export default {
    name: 'ElsklingSymbolColor'
  }
</script>
